<script setup lang="ts">
const root = ref<HTMLElement | null>(null)
useReveal(root)
const portfolioStore = usePortfolioStore()
const supportedSections = ['hero', 'services', 'projects', 'contact']
const sections = computed(() =>
  portfolioStore.visibleSections.filter(section => supportedSections.includes(section))
)
const { active, go } = useActiveSection(sections)
const hasSection = (section: string) => sections.value.includes(section)
</script>

<template>
  <main ref="root" class="mx-auto flex max-w-[1220px] flex-wrap items-stretch gap-0 px-3 py-4 md:px-5 md:py-7">
    <AuraTempPartialsSideBar :active="active" :sections="sections" @go="go" />

    <div class="flex min-w-0 flex-[3_1_640px] flex-col gap-4 rounded-[34px] bg-[var(--t-panel4)] p-4 shadow-[var(--t-clay)] md:rounded-[42px] md:p-6 md:ps-[58px]">
      <AuraTempPartialsHero v-if="hasSection('hero')" />
      <div class="grid gap-3.5" :class="{'lg:grid-cols-1': !hasSection('services'), 'lg:grid-cols-2' : hasSection('services')}">
        <AuraTempPartialsSkills />
        <AuraTempPartialsServices v-if="hasSection('services')" />
      </div>

      <AuraTempPartialsProjects v-if="hasSection('projects')" />
      <AuraTempPartialsContacts v-if="hasSection('contact')" />
      <AuraTempPartialsFooter />
    </div>
  </main>
</template>
